import { useEffect } from "react";

export default function useAttendanceEscapeHandler({ setViewingStudent }) {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") setViewingStudent(null);
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [setViewingStudent]);
}
